import list from "./list";

export default {
    list: list,
    name: "warehouseagenciesv2",
    key: "p_warehouseagenciesv2",
};
